module.exports = __webpack_public_path__ + "static/media/weather-4.0df31055.svg";